<script setup>
const props = defineProps({
  siteAbbr: {
    type: String,
    default: 'wa',
    required: false,
  },
})
const siteAbbrClass = computed(() => `${props.siteAbbr}-loader`)
</script>
<template>
  <div :class="siteAbbrClass">
    <img
      src="~assets/images/wa-loader.gif"
      class="wa-loader-animation"
      data-not-lazy
      alt=""
    />
    <img
      src="~assets/images/svg/wa-loader.svg"
      alt="Wine glass swirling"
      role="img"
      data-not-lazy
    />
  </div>
</template>
